<!-- JAVASCRIPT START -->
<script>
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';

  import Button from '../shared/Button.svelte';
  import FooterPrice from '../shared/FooterPrice.svelte';
  import SidebarTitle from '../shared/SidebarTitle.svelte';
  import Toggle from '../shared/Toggle.svelte';

  const dispatch = createEventDispatcher();
  
  ////////////////
  // Variables
  ////////////////
  export let showPricing = true;
  export let priceTally;
  export let previousStep;
  let selectedCheckbox = [];
  let selectedRadio = null;
  let isRadio;
  let optionsSubtotal = priceTally.usd;


  ////////////////
  // Data
  ////////////////
  const data = {
    "title" : "Select Picker Options",
    "required" : true,
    "multiselect" : false,
    "options" : [
        {
            "id" : 2001,
            "name" : "96 End Effector",
            "price" : 0,
            "showPriceInButton" : true,
            "thumbnail" : "/img/pickerOptions96EndEffector@3x.jpg"
        },
        {
            "id" : 2002,
            "name" : "Universal End Effector with one picker head",
            "price" : 10000,
            "showPriceInButton" : true,
            "thumbnail" : "/img/pickerOptionsUniversalEndEffector@3x.jpg",
            "dependentOptions" : [
              {
                "id" : 2003,
                "name" : "One additional picker head and labware support",
                "price" : 14900,
                "showPriceInButton" : true
              }
            ]
        },
    ],
    "titleToolTip" : `
        <h2>Choosing your picker</h2>
        <div class="text-gray-600 text-xl">
          <p><strong>96-End-Effector (Included)</strong> - Basic End-Effector, enabling the system to pick tubes with volumes of 0.2 to 1.4ml stored in standard 96 format or Hamilton Storage 138 HD format racks. Support for one labware type is included in the system price.</p>
          <hr>
          <p><strong>Universal End-Effector with one Picker Head</strong> - Enables the system to pick tubes and vials with different diameters. Also allows easy tube size adaptation in the future.</p><br>
          <p>Each Tube type with a different diameter (i.e. 96-format / 48-format) requires its own picker head. Support for one labware type is included in the system price.</p>          
        </div>
      `
  };

  function handleSubmitClick() {
    dispatch('nextStep', fetchCartItems());
  }

  function fetchCartItems() {
    let cartItems = [];

    //add madatory radio item
    if(selectedRadio != null){
      cartItems.push(data.options[selectedRadio]);
    }

    //add checkboxes
    if(selectedCheckbox.length > 0){

      for(let i=0; i <= data.options.length - 1; i++) {
        if (data.options[i].dependentOptions){
          for(let j=0; j <= data.options[i].dependentOptions.length - 1; j++) {
            cartItems.push(data.options[1].dependentOptions[j]);
          }
        }
      }
    }

    return cartItems;
  }

  function fetchSubtotal(radioIndex, checkboxIndex) {
    let prices = [priceTally.unformatted];

    //get radio prices
    if(radioIndex != null){
      prices.push(data.options[radioIndex].price);
    }

    //get checkbox prices
    if(checkboxIndex.length > 0){

      for(let i=0; i <= data.options.length - 1; i++) {
        if (data.options[i].dependentOptions){
          for(let j=0; j <= data.options[i].dependentOptions.length - 1; j++) {
            prices.push(data.options[1].dependentOptions[j].price);
          }
        }
      }
    }

    //sum all prices
    let tally = prices.reduce(function(a, b){
        return a + b;
    }, 0);

    return formatPrice(tally);

  }

  const checkButtonDependencies = (optionIndex) => {
    selectedCheckbox = [];
  }
  
  function formatPrice(num){
		let formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});

		return formatter.format(num);
	}
</script>
<!-- JAVASCRIPT END -->



<!-- STYLES START -->
<style>
  
  @media (min-width: 1024px) {
    .bg {
      background-image: url(/img/pickerOptions--hero@3x.jpg);
    }
  }

  .thumbnail {
    @apply rounded-full flex items-center justify-center text-center mx-auto mb-6 shadow-lg;
    width: 40%;
    height: auto;
  }
</style>
<!-- STYLES END -->

 

<!-- HTML START -->

<!-- desktop images -->
<link rel="preload" href="img/additionalOptions--hero@3x.jpg" as="image" media="(min-width: 1024px)">

<!-- mobile images -->
<link rel="preload" href="img/additionalOptions--hero.jpg" as="image" media="(max-width: 1023px)">

<div class="relative lg:h-full lg:overflow-y-hidden">
  <div class="bg absolute top-0 left-0"></div>
	<div class="relative z-10 lg:h-full lg:overflow-y-scroll">
    <div class="flex flex-col lg:flex-row flex-no-wrap w-100 text-lg">
      <div class="flex-column flex-1"></div>
      <div class="flex-column flex-1">
        <div class="bg-white lg:my-12 lg:mb-12 lg:mx-10 lg:rounded lg:shadow-2xl">

          <div class="relative lg:hidden">
            <img class="w-full md:w-1/2 md:m-auto md:mt-10" src="/img/pickerOptions--hero.jpg" alt="Verso Q20 rendering">
            <button class="blueButton absolute bottom-0 inset-x-0 rounded-full text-white text-base px-6 py-2 w-8/12 mx-auto mb-4" on:click={() => dispatch('handleStepBack', {stepName: 0})}>
              <i class="fal fa-long-arrow-left"></i> Back to {previousStep}
            </button>
          </div>

          <SidebarTitle title={data.title} titleToolTip={ data.titleToolTip } />
          
          <main class="flex-grow">

            {#each data.options as option, i (option.id)}
              <div class="p-10">
                <img class="thumbnail" src={option.thumbnail} alt="">

                  <Toggle type='radio' bind:group={selectedRadio} value={i} let:checked={checked} buttonLabel={option.name} buttonPrice={showPricing ? option.showPriceInButton : false} price={option.price} id={option.id} on:toggle={checkButtonDependencies} />

                  {#if option.dependentOptions}
                        
                    {#each option.dependentOptions as dependentOption, j (dependentOption.id)}
                        <Toggle type='checkbox' bind:group={selectedCheckbox} value={j} let:checked={checked} disabled={selectedRadio != 1} buttonLabel={dependentOption.name} buttonPrice={showPricing ? dependentOption.showPriceInButton : false} price={dependentOption.price}  on:toggle={checkButtonDependencies} classes='mt-4' />
                    {/each}
                  {/if}
              </div>

              {#if i < (data.options.length - 1)}
                <div class="py-0">
                  <hr>
                </div>
              {/if}

            {/each}

          </main>

          <footer class="nav flex flex-shrink lg:rounded-b px-10 py-6">
              {#if showPricing}
                <FooterPrice subtotal={ fetchSubtotal(selectedRadio, selectedCheckbox) } />
              {/if}

              <div class="flex-1">
                <Button disabled={data.required && selectedRadio === null} title="Next Step" id="submitButton" on:click={handleSubmitClick} />
              </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HTML END -->